module.exports = __webpack_public_path__ + "static/media/5DPO10.23d90c7c.jpg";